import React, {Component} from 'react'
import strings from "../strings/localeStrings";
import ReactTooltip from "react-tooltip";
import acc from "accounting";
import {Button} from "react-bootstrap";
import moment from "moment";
import ReactModal from "react-modal";
import MapaTrasy from "./wyszukiwarkaComponents/MapaTrasy";
import TopIf from "../topComponents/if/TopIf";

export default class WynikiComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            idKu: ''
        };

    }

    sprawdzMiejsca(item){
        if (item.ileWoln === null) return 'noInfo'
        if (item.ileWoln === 0) return 'freePlaces'
        if (item.ileWoln === 1) return 'standingPlaces'
        if (item.ileWoln === 2) return 'noPlaces'
    }

    sprawdzMiejscaIcon(item){
        if (item.ileWoln === null) return 'fa-question-circle'
        if (item.ileWoln === 0) return 'fa-users'
        if (item.ileWoln === 1) return 'fa-male'
        if (item.ileWoln === 2) return 'fa-times'
    }

    ileWolnych(item) {
        return <div className={"seatsDiv " + this.sprawdzMiejsca(item)} data-tip data-for={(item.idKu + 12345).toString()}
                    data-place="bottom"><i className={"fa " + this.sprawdzMiejscaIcon(item)}> </i> {strings.miejsca}
            <ReactTooltip id={(item.idKu + 12345).toString()}>
                <div className="text-left">
                    {item.ileWoln === null ? 'Brak informacji' : null}
                    {item.ileWoln === 0 ? 'Brak wolnych miejsc' : null}
                    {item.ileWoln === 1 ? 'Tylko miejsca stojące' : null}
                    {item.ileWoln === 2 ? 'Wolne miejsca siedzące' : null}
                </div>
            </ReactTooltip>
        </div>;
    }

    czasPodrozy(item) {
        return <div className="czasPodrozyMobilka"><i className="fa fa-clock-o"> </i> Czas podróży: {item.ileMin} min</div>
    }

    getPogoda(item) {
        if (item.pogOpis === null) {
            return <div className="text-center">Pogoda: Brak danych</div>
        } else {
            return <div className={'pogoda'} data-tip data-for={(item.idKu + 1234567).toString()} data-place="bottom">
                <img src={"https://openweathermap.org/img/w/" + item.pogIcon + ".png"}/>
                <span className={'opisPogoda'}> {item.pogOpis} {item.pogTemp}</span>
                <ReactTooltip id={(item.idKu + 1234567).toString()}>
                    <div className="text-left">
                        Pogoda w {item.nazMiDo}: {item.pogOpis} {item.pogTemp}
                    </div>
                </ReactTooltip>
            </div>
        }
    }

    getWydarzenia(item) {
        return <div className="wydarzenia">
            <a href={item.wydarzeniaUrl} target='_blank'><i className="fa fa-camera"/></a> Wydarzenia
        </div>
    }

    getOczekiwanie(item) {
        if (item.czasOczek > 240) {
            return <div className={'przesiadkaDlugiCzas'}>UWAGA! Długi czas oczekiwania na przesiadkę.</div>
        } else {
            return <hr className={'przesiadkaHr'}/>
        }
    }

    getCzasOczekiwania(item) {
        let wynikGodz = moment(moment(item.godzPrze, 'H:mm').diff(moment(item.godzPrzyPrze, 'H:mm'))).format('HH');
        let wynikMin = moment(moment(item.godzPrze, 'H:mm').diff(moment(item.godzPrzyPrze, 'H:mm'))).format('mm');
        let iloscMin = wynikMin;
        wynikMin = item.czasOczek;
        let minuty = 'minut';
        if (wynikMin === 1) {
            minuty = 'minuta'
        }
        return <div data-tip data-for={(item.idKu + 123456).toString()} data-place="bottom"
                    className="czasOczekiwania">
            {wynikMin > 240 ?
                <span style={{color: 'red'}}><i className="fa fa-exclamation"/>{item.czasOczek} {minuty}</span> :
                <span>  <i className="fa fa-arrows-v"> </i>
                    {item.czasOczek} {minuty}</span>}
            <ReactTooltip id={(item.idKu + 123456).toString()}>
                {wynikMin > 240 ? <div className="text-center">
                    <b>UWAGA!</b>
                    <div>Długi czas oczekiwania: {parseInt(wynikMin)} min</div>
                </div> : <div className="text-left">
                    Czas oczekiwania: {parseInt(wynikGodz) - 1} godz. {parseInt(iloscMin)} min
                </div>}
            </ReactTooltip></div>
    }

    getButton(item) {
        if (item.czyOdwolano === true) {
            return <div className={'buttonWynikiClass'} style={{color: 'red'}}>
                Kurs odwołany
            </div>
        } else {
            if (item.czyZablok === 1 && (item.czyEBilet || item.czyERezerwacja)) {
                return <div data-tip
                            data-for={(item.idKu + 123456789).toString()}
                            data-place="bottom" className={'buttonWynikiClass blokada'} style={{
                    color: '#c1c1c1'
                }}
                ><ReactTooltip id={(item.idKu + 123456789).toString()}>
                    <div className="text-left">
                        {item.uwagi === "Zablokowany!" ? "Kurs został zablokowany" : item.uwagi}
                    </div>
                </ReactTooltip>
                    Sprzedaż zablokowana
                </div>
            } else {
                return <Button onClick={() => {
                    item.czyEBilet && !item.czyZablok ? this.props.pokazSzczegoly(item.idKu, '0') : this.props.wyswietlNotyfikacje('brakBiletow')
                }} bsStyle={item.czyEBilet && !item.czyZablok ? 'success' : 'disabled'} className="buttonWynikiClass buttonWybierzMobilka"> {strings.wybierz}
                </Button>
            }
        }
    }

    getCena(item) {
        if (item.idTrPrze !== null) {
            if (item.cenaMin === item.cena) {
                return <span className="text-center" data-tip data-for={(item.idKu + 12345678).toString()}
                             data-place="bottom">
                    <span className="cenaProm"><i className={'fa fa-info-circle'}/> {acc.formatMoney(item.cenaMin, {
                        symbol: "zł",
                        format: "%v %s"
                    })}</span>
                    <ReactTooltip id={(item.idKu + 12345678).toString()}>
                   {Boolean(item.nazZnizMin) ? <div className="text-left">
                    Bilet {item.nazZnizMin.toLowerCase()}: {acc.formatMoney(item.cenaMin, {
                        symbol: "zł",
                        format: "%v %s"
                    })}
                    </div> : <div>Brak informacji</div>}
                    </ReactTooltip></span>
            } else {
                return <span className="text-center" data-tip data-for={(item.idKu + 12345678).toString()}
                             data-place="bottom">
                    <span className="cenaProm"><i className={'fa fa-info-circle'}/> {acc.formatMoney(item.cenaMin, {
                        symbol: "zł",
                        format: "%v %s"
                    })}</span>
                    <ReactTooltip id={(item.idKu + 12345678).toString()}>
                     {Boolean(item.nazZnizMin) ? <div className="text-left">
                    Bilet {item.nazZnizMin.toLowerCase()}: {acc.formatMoney(item.cenaMin, {
                        symbol: "zł",
                        format: "%v %s"
                    })}
                    </div> : <div>Brak informacji</div>}
                    </ReactTooltip></span>
            }
        } else {
            if (item.cenaMin === item.cena) {
                return <span className="text-center" data-tip data-for={(item.idKu + 12345678).toString()}
                             data-place="bottom">
                    <span className="cena2"><i className={'fa fa-ticket'}/> {acc.formatMoney(item.cena, {
                        symbol: "zł",
                        format: "%v %s"
                    })}</span>
                    <ReactTooltip id={(item.idKu + 12345678).toString()}>
                    <div className="text-left">
                    Bilet normalny: {acc.formatMoney(item.cena, {
                        symbol: "zł",
                        format: "%v %s"
                    })}
                    </div>
                    </ReactTooltip></span>
            } else {
                if (item.rodzMin === 'SU') {
                    return <span className="text-center" data-tip data-for={(item.idKu + 12345678).toString()}
                                 data-place="bottom">
                    <span className="cenaProm"><i className={'fa fa-graduation-cap'}/> {acc.formatMoney(item.cenaMin, {
                        symbol: "zł",
                        format: "%v %s"
                    })}</span>
                    <ReactTooltip id={(item.idKu + 12345678).toString()}>
                    {Boolean(item.nazZnizMin) ? <div className="text-left">
                    Bilet {item.nazZnizMin.toLowerCase()}: {acc.formatMoney(item.cenaMin, {
                        symbol: "zł",
                        format: "%v %s"
                    })}
                    </div> : <div>Brak informacji</div>}
                    </ReactTooltip></span>
                } else {
                    return <span className="text-center" data-tip data-for={(item.idKu + 12345678).toString()}
                                 data-place="bottom">
                    <span className="cenaProm"><i className={'fa fa-info-circle'}/> {acc.formatMoney(item.cenaMin, {
                        symbol: "zł",
                        format: "%v %s"
                    })}</span>
                    <ReactTooltip id={(item.idKu + 12345678).toString()}>
                   {Boolean(item.nazZnizMin) ? <div className="text-left">
                    Bilet {item.nazZnizMin.toLowerCase()}: {acc.formatMoney(item.cenaMin, {
                        symbol: "zł",
                        format: "%v %s"
                    })}
                    </div> : <div>Brak informacji</div>}
                    </ReactTooltip></span>
                }

            }
        }
    }

    openModal(idKu, nazPrDo, nazPrOd) {
        this.setState({idKu: idKu, nazPrDo: nazPrDo, nazPrOd: nazPrOd, showModal: true});
    }

    render() {
        return <div>
            <ReactModal
                isOpen={this.state.showModal}
                contentLabel="Mapa trasy"
                ariaHideApp={false}
            >
                <div className="row">
                    <div className="col-sm-12 text-right" style={{marginBottom: '5px'}}>
                        <Button bsStyle={'danger'} bsSize={'small'} onClick={()=>this.setState({showModal: false})}>
                            <i className="fa fa-times" style={{color: 'white'}}> </i>
                        </Button>
                    </div>
                </div>
                <MapaTrasy idKu={this.state.idKu} nazPrDo={this.state.nazPrDo} nazPrOd={this.state.nazPrOd}/>
            </ReactModal>
            {this.props.data.length !== 0 ?
                <div>{this.props.data.map((item, index) => {
                    return (
                        <div className={"wynik " + (this.props.powrotny ? (this.props.params.dataPow === moment().toISOString().substr(0, 10) && item.godz1p < this.props.params.godzinaPow ? "trwa" : "") : (this.props.params.data === moment().toISOString().substr(0, 10) && item.godz1p < this.props.params.godzina ? "trwa" : "")) + " " + (this.props.wyswietlSzczegoly[item.idKu] || this.props.wyswietlCennik[item.idKu] ? 'addBorder' : '')}>
                            <div key={"kurs" + item.idKu}
                                 className={"row kurs"}>
                                <div className="col-xs-1 godzinyWynik"
                                     style={{
                                         textAlign: 'right',
                                         paddingLeft: 0,
                                         paddingRight: 0
                                     }}>
                                    <div className="godzinaOdjazd">{item.godz} <i
                                        className="fa fa-arrow-right"> </i>
                                    </div>
                                    <TopIf isTrue={item.godzPrze !== null}>
                                        <div className="godzinaPrzesiadkaPrzyjazd">{item.godzPrzyPrze} <i
                                            className="fa fa-arrow-left"> </i></div>
                                        <div>{this.getCzasOczekiwania(item)}</div>
                                        <div className="godzinaPrzesiadkaOdjazd">{item.godzPrze} <i
                                            className="fa fa-arrow-right"> </i></div>
                                    </TopIf>
                                    <div className="godzinaPrzyjazd">{item.godzPrzy} <i
                                        className="fa fa-arrow-left"> </i></div>
                                </div>
                                <div className="col-sm-6 miejscaWynik"
                                     style={{paddingLeft: 15, paddingRight: 0}}>
                                    <div className="miejsceOdjazd">{item.nazMiOd}
                                        <span> {item.nazPrOd}</span></div>
                                    <TopIf isTrue={item.nazMiPrze !== null}>
                                        <div
                                            className="miejscePrzesiadka">{item.nazMiPrze}
                                            <span> {item.nazPrPrzeOd}</span></div>
                                        {this.getOczekiwanie(item)}
                                        <div
                                            className="miejscePrzesiadka">{item.nazMiPrze}
                                            <span> {item.nazPrPrzeDo}</span></div>
                                    </TopIf>
                                    <div className="miejscePrzyjazd">{item.nazMiDo}
                                        <span> {item.nazPrDo}</span></div>
                                </div>
                                <div className="col-sm-3 trasaCol"
                                     style={{paddingLeft: 0, paddingRight: 0}}>
                                    <div className="trasa">{strings.trasa}: <span>{item.nazTr}</span>
                                    </div>
                                    <div className="trasa-pokazMape" style={{color: '#858585', cursor: 'pointer'}}
                                         onClick={() => {
                                             item.nazTrPrze !== null ? this.openModal(item.idKu, item.nazPrPrzeOd, item.nazPrOd) : this.openModal(item.idKu, item.nazPrDo, item.nazPrOd)
                                         }}>
                                        <i className="fa fa-map-marker"> </i> Pokaż mapę trasy
                                    </div>
                                    <TopIf isTrue={item.nazTrPrze !== null}>
                                        <div style={{lineHeight: '27px'}}>&nbsp;</div>
                                        <div className="trasaPrzesiadka">
                                            {strings.trasa}: <span>{item.nazTrPrze}</span>
                                        </div>
                                        <div className="trasa-pokazMape" style={{color: '#858585', cursor: 'pointer'}}
                                             onClick={() => this.openModal(item.idKuPrze, item.nazPrDo, item.nazPrPrzeDo)}>
                                            <i className="fa fa-map-marker"> </i> Pokaż mapę trasy
                                        </div>
                                    </TopIf>
                                </div>
                                <div className="col-sm-2 buttonWybierzMobilkaContainer"
                                     style={{paddingLeft: 45, position: 'relative'}}>
                                    {this.getButton(item)}
                                </div>
                            </div>
                            <div className={"row displayNoneMobilka"} style={{marginTop: 5}}>
                                <div className="col-sm-10 text-center pokazCennikDiv">
                                    <a style={{color: '#007bff', cursor: 'pointer'}}
                                       onClick={() => this.props.pokazCennik(item.idKu, '0')}>{this.props.wyswietlCennik[item.idKu] ? 'Ukryj cennik biletów' : 'Pokaż cennik biletów'}</a>
                                </div>
                            </div>
                            <hr className="unvisible"/>
                            <div className="row dodatkoweInfoMobilka"
                                 style={{paddingLeft: 10, fontSize: '0.875rem', lineHeight: '30px'}}>
                                <div className="col-sm-3">
                                    {this.czasPodrozy(item)}
                                </div>
                                <div className="col-sm-2">
                                    {this.ileWolnych(item)}
                                </div>
                                <div className="col-sm-2">
                                    {this.getWydarzenia(item)}
                                </div>
                                <div className="col-sm-3">
                                    {this.getPogoda(item)}
                                </div>
                                <div className="col-sm-2" style={{whiteSpace: 'nowrap'}}>
                                    {strings.cena}: {this.getCena(item)}
                                </div>
                            </div>

                            {this.props.wyswietlSzczegoly[item.idKu] &&
                            this.props.renderujSzczegoly(item, this.props.powrotny)
                            }

                            {this.props.wyswietlCennik[item.idKu] &&
                            this.props.renderujCennik(item, false)
                            }
                        </div>
                    );
                })}</div> :
                <div className="wynik">
                    <div className="text-center" style={{paddingTop: 50, paddingBottom: 50}}>
                        <h4>{strings.brakPolaczen}</h4></div>
                </div>}
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/wyszukiwarka/WynikiComponent.js